import React from 'react';
import translate from './translate';
import beeBadge from './bee_badge.png';

const KindergartenBeeBadge_fi = (): JSX.Element => {
  return (
    <div>
      <p><mark>Harmonia-Hiiren häntä viuhuu matkalaukussa. Se toivoo löytävänsä sieltä jotakin hienoa. Yhtäkkiä sen käpäliin osuu jotakin kovaa. Harmonia nostaa ja näyttää merkkiä Lotalle ja Oodille. Kaverukset tutkivat sitä yhdessä, ja miettivät, mikä merkin tarina on. Ullakon seinien raoista kuuluu naapuruston iloisia ääniä. Naapurit ovat yhdessä päättäneet maalata läheisen leikkipuiston välinevaraston.</mark></p>
      <p><strong>Lasten ja nuorten talkoot</strong></p>
      <img className="large" src={beeBadge} alt={translate('bee_badge')}/>
      <p><em>Vuoden 1943 kotirintaman talkoomerkki (Turun museokeskuksen lisenssi cc by nd-4.0)</em></p>
      <p><em>Nuorten Talkoot oli vapaaehtoista toimintaa lasten ja nuorten keskuudessa. Mm. </em><a target="_blank" rel="noreferrer" href="https://fi.wikipedia.org/wiki/Lotta_Sv%C3%A4rd"><em>Lotta Svärd</em></a><em> -järjestön pikkulottina toimi 40 000 tyttöä 8- ja 16-ikävuoden väliltä. Nuorten Talkoiden toiminta jakaantui talkootyöhön, keräilyyn ja säästötalkoisiin.</em></p>
      <p>(<a target="_blank" rel="noreferrer" href="https://www.lottasvard.fi/lottagalleria/lottajarjeston-jaostot/#!/kerays-ja-huoltojaosto">Lottajärjestön jaostot - Lotta Svärd - Verkkomuseo (lottasvard.fi)</a></p>
      <p><strong>Pohdinta-/Tehtävävinkkejä: </strong></p>
      <ul>
        <li>Pohtikaa yhdessä lasten kanssa, mitä tarkoittaa talkoot.</li>
      </ul>
      <ul>
        <li>Oletko sinä osallistunut joskus talkoisiin? Minkälaisia erilaisia talkootilanteita on olemassa/voisi olla?</li>
      </ul>
      <ul>
        <li>Suunnitelkaa yhdessä oma talkoomerkki.</li>
      </ul>
      <ul>
        <li>Mitä suunnittelussa tulisi ottaa huomioon? Esimerkiksi miten ja mihin se voidaan kiinnittää? Mistä materiaalista, millä välineillä ja millaisin työtavoin sitä voidaan työstää ja toteuttaa? (<em>huom! monimateriaalisuus ja kierrätysmateriaalien hyödyntäminen)</em></li>
      </ul>
      <ul>
        <li>Miten voit esimerkiksi tehdä näitä merkkejä?
          <ul>
            <li>piirtämällä tai maalaamalla</li>
            <li>askartelemalla (esim. kierrätysmateriaaleista)</li>
            <li>tutustumalla tietokoneen piirtämis- ja suunnitteluohjelmaan, jotka voi esim. tulostaa tarrapaperille tai liittää omaan portfolioon/Vasuun</li>
            <li>ompelemalla (huovasta, kankaista)</li>
            <li>taivuttamalla esim. metallilankaa</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>Keksikää joku talkoohenkinen työ tai toiminta, joka hyödyttäisi yhteisöä (ystävänpäivä-/pääsiäis-/joulukorttien tekeminen ja lähettäminen vanhainkoteihin, roskien kerääminen päiväkodin/vanhainkodin ympäristöstä).</li>
      </ul>
      <ul>
        <li>Miten talkootöissä voi huomioida kestävän kehityksen ja kierrätyksen? (Voitte käydä päiväkodin pelit/kirjat läpi ja korjata/huoltaa ne.)</li>
      </ul>
      <ul>
        <li>Pohtikaa yhdessä lasten kanssa mitä tarkoittaa keräily. Mitä se oli ennen? Mitä nykypäivänä voisi keräillä? Harrastaako joku keräilyä?</li>
      </ul>
      <p><strong>Lisätietoa Nuorten Talkoista:</strong></p>
      <p><em>Nuorten Talkoiden toimintatapa oli laadittu kilpailulliseksi niin, että joka vuosi kerättiin pisteitä eri tehtävistä, ja syksyisin ahkeruudesta sai kullatun, hopeoidun tai rautaisen talkoomerkin. ”Romumuurahaismerkin” sai keräämällä 20 ehjää pulloa, ”talkoomuurahaismerkin” jos keräsi tietyn määrän jätepuita tai käpyjä autettavalle perheelle. </em></p>
      <p>(<a target="_blank" rel="noreferrer" href="https://fi.wikipedia.org/wiki/Nuorten_Talkoot">https://fi.wikipedia.org/wiki/Nuorten_Talkoot</a>.)</p>
      <p><em>“Lottajärjestön keräystoiminta oli varsin monimuotoista. Tuottoisimpia keräysmuotoja olivat arpajaiset ja erilaiset myyntikampanjat. Lottajulkaisujen myyminen ja lehtitilausten kerääminen kuuluivat keräysjaoston vakiotehtäviin.”</em></p>
      <p>(<a target="_blank" rel="noreferrer" href="https://www.lottasvard.fi/lottagalleria/lottajarjeston-jaostot/#!/kerays-ja-huoltojaosto">Lottajärjestön jaostot - Lotta Svärd - Verkkomuseo (lottasvard.fi)</a>)</p>
      <p><strong>KOODITEHTÄVÄ 2.: Mikä on merkissä näkyvän vuosiluvun kolmannen numeron ensimmäinen kirjain?</strong></p>
    </div>
  );
};

export default KindergartenBeeBadge_fi;
